// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api/merchant'

// Local Storage Keys
// Using 'merchantToken' to match existing vanilla JS implementation
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'merchantToken',
  MERCHANT_ID: 'logicloom_merchant_id',
}

// Transaction Status
export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
}

// Payout Status
export const PAYOUT_STATUS = {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
}

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  DISPLAY_WITH_TIME: 'MMM dd, yyyy HH:mm',
  API: 'yyyy-MM-dd',
  FULL: 'yyyy-MM-dd HH:mm:ss',
}

// Pagination
export const DEFAULT_PAGE_SIZE = 10
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

// Debounce Delays
export const DEBOUNCE_DELAY = 500

